import React from "react"
import { Helmet } from "react-helmet"
import { hasWindow } from "src/lib/utils/window"
import { isContentfulDevelop } from 'logic/utils/utils';

interface SEOProps {
  title?: string
  image?: string
  description?: string
  noIndex?: boolean
}

export const Seo: React.FC<SEOProps> = ({
  title,
  description,
  image,
  noIndex = false,
}) => {
  const url = hasWindow ? window.location.href : ""
  const metaTitle = title || ""
  const metaDescription = description || ""
  const metaImage =
    image ||
    "https://api2.dev.tutorspace.de/file/5fa96ca3e620de00117019c5/content/TutorSpaceMetaImage.png"

  return (
    <Helmet>
      <html lang="de" />
      {metaImage && <meta property="twitter:image" content={metaImage} />}
      {metaImage && <meta property="og:image" content={metaImage} />}
      <meta name="author" content="tutorspace.de" />
      <meta name="twitter:site" content="tutorspace.de" />
      {metaTitle && <title>{metaTitle}</title>}
      {metaTitle && <meta name="twitter:title" content={metaTitle} />}
      {metaTitle && <meta property="og:title" content={metaTitle} />}
      {metaTitle && <meta property="article:tag" content={metaTitle} />}
      {metaDescription && <meta name="description" content={metaDescription} />}
      {metaDescription && (
        <meta property="og:description" content={metaDescription} />
      )}
      {metaDescription && (
        <meta name="twitter:description" content={metaDescription} />
      )}
      <meta property="og:site_name" content="tutorspace.de" />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="article" />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="fb:app_id" content="299504410786440" />
      {(isContentfulDevelop() || noIndex) && (
        <meta name="robots" content="noindex" />
      )}
    </Helmet>
  )
}
